import { combineReducers } from 'redux'
import perfilReducer from './perfil'
import tokenReducer from './token'
import generalReducer from './general'

export default combineReducers({
  perfil: perfilReducer,
  token: tokenReducer,
  general: generalReducer
})